import { Component, OnInit } from '@angular/core';
import { AppVmsService } from "../../services/app-vms.service";
import { AppVms } from "../../model/AppVms";
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SuperButtonComponent, PageActionComponent } from '@qid/super';
import { SexyModule } from '@qid/sexy';
import { IonHeader, IonToolbar, IonTitle, IonContent, IonAccordionGroup, IonAccordion, IonItem, IonLabel, IonListHeader, IonToggle, IonInput } from '@ionic/angular/standalone';

@Component({
  selector: 'app-app-vms',
  templateUrl: './app-vms.page.html',
  styleUrls: ['./app-vms.page.scss'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    SexyModule,
    SuperButtonComponent,
    PageActionComponent,
    IonHeader,
    IonToolbar,
    IonTitle,
    IonContent,
    IonAccordionGroup,
    IonAccordion,
    IonItem,
    IonLabel,
    IonListHeader,
    IonToggle,
    IonInput
  ]
})
export class AppVmsPage implements OnInit {

  public appVms: AppVms = null;

  public authProviders = ["google", "apple", "phone", "email", "whatsapp"]

  constructor(private appVMSService: AppVmsService) {
  }

  ngOnInit() {
  }

  ionViewDidEnter() {
    this.fetchVMS()
  }

  private async fetchVMS() {
    this.appVms = await this.appVMSService.getVMS()
    if (!this.appVms || !this.appVms._id) {
      this.appVms = new AppVms()
    }
  }

  public update = async () => {
    await this.appVMSService.update(this.appVms)
  };

}
